import type { Resource } from "@e308/core";
import type { UnitId } from "./content/buildings.js";
import type { SeatModel, SeatResources } from "./content-types.js";
import type { EconomyBuilding } from "./economy-types.js";
import type { Micro } from "./exact-numbers.js";

export function buildingResource(resources: SeatResources, id: EconomyBuilding): Resource<Micro> {
  const key = {
    "mining-rig": "miningRig",
    "power-generator": "powerGenerator",
    "construction-yard": "constructionYard",
    "rig-factory": "rigFactory",
    "yard-factory": "yardFactory",
    "factory-works": "factoryWorks",
    "robot-factory": "robotFactory",
    "research-lab": "researchLab",
    "shield-generator": "shieldGenerator",
    "supply-depot": "supplyDepot",
  } as const;
  return resources[key[id]];
}

export function unitResource(resources: SeatResources, id: UnitId): Resource<Micro> {
  const key = {
    "guard-robot": "guardRobot",
    "raider-robot": "raiderRobot",
    "siege-gun": "siegeGun",
  } as const;
  return resources[key[id]];
}

export function modelBuildingResource(model: SeatModel, id: EconomyBuilding): Resource<Micro> {
  return buildingResource(model.resources, id);
}
